export const LOGIN_MODE = {
  PASSWORD: 'password',
  OTP: 'otp',
} as const;

export type LoginMode = (typeof LOGIN_MODE)[keyof typeof LOGIN_MODE];

export type LoginProps = {
  initialEmail: string;
  onSignup: (email: string) => void;
  onForgotPassword: () => void;
  onChangeEmail?: (email: string) => void;
  onModeSelected?: (mode: LoginMode) => void;
  onCodeSent?: () => void;
  onCodeValidated?: () => void;
  /** The buyer is signed in, by either method. */
  onLoginCompleted?: (mode: LoginMode) => void;
  submitLabel?: string;
  passwordSubtitle?: string;
  signupLabel?: string;
};
